import { SCHEDULING_LINK_UNAVAILABLE_PATH } from "./publicCalendlyUrl";
import { PRODUCTION_APP_HOSTS } from "../constants/api-constants";

export const PUBLIC_JOBS_HOST = "jobs.asqio.ai";
export const RECRUITMENT_PRIVACY_PATH = "/privacy/recruitment";

const publicJobsOrigin = (location: Pick<Location, "hostname" | "origin">) =>
  location.hostname === PUBLIC_JOBS_HOST ||
  PRODUCTION_APP_HOSTS.has(location.hostname)
    ? `https://${PUBLIC_JOBS_HOST}`
    : location.origin;

export const buildPublicJobUrl = (
  slug: string,
  location: Pick<Location, "hostname" | "origin"> = window.location,
) => `${publicJobsOrigin(location)}/j/${encodeURIComponent(slug)}`;

export const buildRecruitmentPrivacyUrl = (
  location: Pick<Location, "hostname" | "origin"> = window.location,
) => `${publicJobsOrigin(location)}${RECRUITMENT_PRIVACY_PATH}`;

export const isPublicJobsLocation = ({
  hostname,
  pathname,
}: {
  hostname: string;
  pathname: string;
}) =>
  hostname === PUBLIC_JOBS_HOST ||
  pathname === "/j" ||
  pathname.startsWith("/j/") ||
  pathname === SCHEDULING_LINK_UNAVAILABLE_PATH ||
  pathname === `${SCHEDULING_LINK_UNAVAILABLE_PATH}/` ||
  pathname === RECRUITMENT_PRIVACY_PATH ||
  pathname === `${RECRUITMENT_PRIVACY_PATH}/`;
